import { CheckableType } from '../common/props';
import { ReactNode } from 'react';

export enum CheckStatus {
  ALL_CHECKED = 'ALL_CHECKED',
  ALL_UNCHECKED = 'ALL_UNCHECKED',
  SOME_CHECKED = 'SOME_CHECKED',
}

export interface IData<ID> {
  id?: ID;
}

export type ExtraProps = {
  // Počet záznamů v tabulce
  totalElements?: number;
  // Nadpis tabulky
  title?: ReactNode;
};

export type CommonRenderer<ID extends unknown> = {
  headerProps: {
    checkedStatus: CheckStatus;
    onToggleCheckAll: () => void;
    checkable: CheckableType;
    disabled: boolean;
    // @deprecated - přesunuto do extraProps, aby bylo možné rovnou dávat <DataTableExtra {...headerProps.extraProps}></DataTableExtra>
    totalElements?: number;
    extraProps: ExtraProps;
  };
  checkAll: (allChecked: boolean) => void;
  checkedIds: ID[];
};

export type VirtualDataRef<ID extends unknown> = {
  invalidate: (ids?: ID[]) => void;
};

export const computeCheckAll = <ID extends unknown>(
  ids: ID[]
): { [key: string]: boolean } => {
  const checkedMap: { [key: string]: boolean } = {};
  ids.forEach((id) => {
    checkedMap[`${id}`] = true;
  });
  return checkedMap;
};

export type RowRenderProps<ID extends unknown, DATA extends object> = {
  checkable?: CheckableType;
  checked?: boolean;
  highlight?: boolean;
  onCheck?: () => void;
  id: ID;
  isFetching: boolean;
  isDeleted: boolean;
  isFetched: boolean;
  row: undefined | null | DATA;
  index: number;
};

export const computeCheckedIds = <ID extends unknown>(
  ids: ID[],
  checkedIds: { [key: string]: boolean }
): ID[] => {
  const result = [];
  for (let a = 0; a < ids.length; a++) {
    let id = ids[a];
    const strId = `${id}`;
    if (checkedIds[strId]) {
      result.push(id);
    }
  }
  return result;
};

export const computeCheckedStatus = <ID extends unknown>(
  ids: ID[] | undefined,
  checkedIds: { [key: string]: boolean }
): CheckStatus => {
  if (ids) {
    let someChecked = false;
    let someUnchecked = false;
    for (let a = 0; a < ids.length; a++) {
      const strId = `${ids[a]}`;
      if (checkedIds[strId]) {
        someChecked = true;
      } else {
        someUnchecked = true;
      }

      if (someChecked && someUnchecked) {
        break;
      }
    }

    if (someChecked && someUnchecked) {
      return CheckStatus.SOME_CHECKED;
    } else if (someChecked) {
      return CheckStatus.ALL_CHECKED;
    } else if (someUnchecked) {
      return CheckStatus.ALL_UNCHECKED;
    } else {
      return CheckStatus.ALL_UNCHECKED;
    }
  } else {
    if (Object.values(checkedIds).find((v) => v)) {
      return CheckStatus.SOME_CHECKED;
    } else {
      return CheckStatus.ALL_UNCHECKED;
    }
  }
};
